import { render, staticRenderFns } from "./TelemedicineToStartForm.vue?vue&type=template&id=6c5af78c&scoped=true&"
import script from "./TelemedicineToStartForm.vue?vue&type=script&lang=js&"
export * from "./TelemedicineToStartForm.vue?vue&type=script&lang=js&"
import style0 from "./TelemedicineToStartForm.vue?vue&type=style&index=0&id=6c5af78c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5af78c",
  null
  
)

export default component.exports